import React, {useContext, useMemo} from 'react'
import {Button} from 'shared/ui/buttons'
import {Modal} from 'shared/ui/modal'
import {WarningModalContext, WarningModalContextType} from './context'
import styles from './styles.module.scss'

export const WarningModal = () => {
  const {header, text, setWarningModal} = useContext(WarningModalContext) as WarningModalContextType
  const isOpen = useMemo(() => Boolean(header && text), [header, text])
  const onClose = () => setWarningModal({})

  if (!isOpen) return <></>

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          {header}
        </div>
        <div className={styles.text}>
          {text}
        </div>
        <Button styleType='transparentPrimary' fullwidth onClick={onClose}>OK</Button>
      </div>
    </Modal>
  )
}
